import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ENVIRONMENT_WEBSITE_TOKEN } from '@campus/environment';

@Component({
  standalone: false,
  selector: 'campus-faq-section',
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqSectionComponent {
  private environmentWebsite = inject(ENVIRONMENT_WEBSITE_TOKEN);

  public studentFaqUrl = this.environmentWebsite.faqUrl?.student;
  public teacherFaqUrl = this.environmentWebsite.faqUrl?.teacher;
  public adminFaqUrl = this.environmentWebsite.faqUrl?.admin;
}
